export default "__VITE_ASSET__3794b11d__"